// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__NzGhE","input":"search_input__c3Vaw","label":"search_label__1OYNe","error":"search_error__2_d9e"};